/* eslint-disable no-const-assign */
/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable eqeqeq */

import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { AiTwotoneNotification } from 'react-icons/ai';
import axios from 'axios';
import { FaBars, FaUserFriends, FaUserMd } from 'react-icons/fa';

import { IoMdLock } from 'react-icons/io';
import { AiOutlineRise, AiOutlineCalendar } from 'react-icons/ai';
import { MdNotificationsActive } from 'react-icons/md';
import {
  RiDashboardFill,
  RiEditBoxFill,
  RiLogoutBoxRFill,
} from 'react-icons/ri';
import { Link, useNavigate } from 'react-router-dom';
import {
  default as footerLogo,
  default as logo,
} from '../../assets/app-logo.png';
import profileImage from '../../assets/images/profileAvator.png';
import { ErrorAlert } from '../../components/ErrorAlert';
import { WarningAlert } from '../../components/alert/WarningAlert';
import { ChartsMain } from '../../components/ChartsMain';
import { PieChart } from '../../components/piechart/PieChaer';

import Counter from '../../components/counters/counter';
import './mychart.css';
import '../../components/home/styles.css';
import '../../components/login/styles.css';
import { UpcomingEventList } from '../../components/event/upcoming-event-list';

import { FaPlus } from 'react-icons/fa';
import {
  AddAnnoucementModal,
  AddUpcomingEventModal,
} from '../../components/event-modal/add-upcoming-event';
import { colorTheme } from '../../utilities/ColorTheme';
import { AddEventRecordingModal } from '../../components/event-modal/add-event-recording';
import { PastEventList } from '../../components/event/past-event-list';
import { BASE_URL, Endpoints } from '../../constants/urls';
import { logoutUser } from '../../store/authSlice';
import { AddPastEventModal } from '../../components/event-modal/add-past-event';

export const Admin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedSection, setSelectedSection] = useState('section1');
  const [selectedSectionTitle, setSelectedSectionTitle] = useState('Analytics');
  const [message, setMessage] = useState('');
  const [data, setData] = useState(null);
  const [upcomingEventsChartData, setUpcomingEventsChartData] = useState([]);
  const [pastEventsChartData, setPastEventsChartData] = useState([]);
  const [upcomingEventsCount, setUpcomingEventsCount] = useState(0);
  const [pastEventsCount, setPastEventsCount] = useState(0);
  const [updateNotificationsList, setUpdateNotificationsList] = useState(false);
  const [isAnnoucementReload, setIsAnnoucementReload] = useState(false);
  const [logoutAlert, setLogoutAlert] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [showComingEventModal, setShowComingEventModal] = useState(false);
  const [showEventRecordingModal, setShowEventRecordingModal] = useState(false);
  const [showPastEventModal, setShowPastEventModal] = useState(false);

  useEffect(() => {
    handleUpcomingEventsChartData();
    handlePastEventsChartData();
    handleDashboardEventsCounter();
  }, []);

  const handleUpcomingEventsChartData = () => {
    axios
      .get(`${BASE_URL}Events/GetUpcomingEventsChartData`)
      .then((response) => {
        setUpcomingEventsChartData(response?.data);
      })
      .catch((error) => {
        console.error('There was an error making the GET request!', error);
      });
  };

  const handlePastEventsChartData = () => {
    axios
      .get(`${BASE_URL}Events/GetPastEventsChartData`)
      .then((response) => {
        setPastEventsChartData(response?.data);
      })
      .catch((error) => {
        console.error('There was an error making the GET request!', error);
      });
  };

  const handleDashboardEventsCounter = () => {
    axios
      .get(`${BASE_URL}Events/GetDashboardEventsCounter`)
      .then((response) => {
        setUpcomingEventsCount(response?.data?.upcomingEventCount);
        setPastEventsCount(response?.data?.pastEventCount);
      })
      .catch((error) => {
        console.error('There was an error making the GET request!', error);
      });
  };

  const userLogout = () => {
    localStorage.removeItem('accessToken');
    dispatch(logoutUser());
    navigate('/', { replace: true });
  };

  const handleScroll = (event) => {
    // setScrollTop(event.currentTarget.scrollTop);
  };
  let sideBar = [
    {
      section: 'section1',
      heading: 'Analytics',
      title: 'Analytics',
      icon: <RiDashboardFill />,
    },

    {
      section: 'section3',
      heading: 'Create Announcement',
      title: 'Upcoming Events',
      icon: <AiOutlineRise />,
    },
    {
      section: 'section2',
      heading: 'Create Announcement',
      title: 'Past Events',
      icon: <AiOutlineCalendar />,
    },
  ];

  console.log('compoenet recreated', selectedSection);

  return (
    <>
      <div style={{ backgroundColor: '#f7f7f7' }} className='d-flex '>
        <div className={'sideNavbarMain d-none d-lg-block'}>
          <div className='sideNavbar-Content'>
            <Link to={'/admin-home'}>
              <div className='topLogoDashboard text-center'>
                <img src={logo} alt='logo' width={142} />
              </div>
            </Link>
            <ul className='ps-0 mt-3'>
              {sideBar.map((item, i) => (
                <li key={i}>
                  <a
                    onClick={() => {
                      setSelectedSection(item.section);
                      setSelectedSectionTitle(item.title);
                    }}
                    data-section='analyticsSection'
                    className='sideNavbarAnchar'
                  >
                    <span className='sidenavIcon'>{item.icon}</span>
                    <span>{item.title}</span>
                  </a>
                </li>
              ))}
              <div style={{ padding: '9px 12px' }}>
                <Link
                  onClick={() => setLogoutAlert(true)}
                  className='sideNavbarAnchar'
                >
                  <span className='sidenavIcon'>
                    <RiLogoutBoxRFill />
                  </span>
                  <span>Logout</span>
                </Link>
              </div>
            </ul>
          </div>
        </div>
        <div
          style={{ maxWidth: '60%' }}
          className='offcanvas offcanvas-start bg-white'
          id='offcanvasWithBackdrop'
          aria-labelledby='offcanvasWithBackdropLabel'
        >
          <div className='sideNavbar-Content'>
            <Link to={'/admin-home'}>
              <div className='topLogoDashboard text-center'>
                <img src={logo} alt='logo' width={120} />
              </div>
            </Link>
            <ul className='ps-0 mt-3'>
              {sideBar.map((item, i) => (
                <li
                  key={i}
                  data-bs-toggle='offcanvas'
                  data-bs-target='#offcanvasWithBackdrop'
                >
                  <a
                    onClick={() => {
                      setSelectedSection(item.section);
                      setSelectedSectionTitle(item.heading);
                    }}
                    data-section='analyticsSection'
                    className='sideNavbarAnchar'
                  >
                    <span className='sidenavIcon'>{item.icon}</span>
                    <span>{item.title}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div
          className={'myChartMain w-100 pb-5 pt-3  px-4'}
          onScroll={handleScroll}
        >
          <div className='top-navbar-container'>
            <div className='top-navbar d-flex align-items-center w-100'>
              <div className='top-nav-left d-flex align-items-center'>
                <h5 className='mb-0'>{selectedSectionTitle}</h5>
              </div>
              <div className='top-nav-right d-none d-sm-flex'>
                {/* <span className='topnavIcon'>
                  <MdNotificationsActive />
                </span> */}
                <span className='nav-user'>
                  <span className='userimage'>
                    <img src={profileImage} alt='user-image'></img>
                  </span>
                  <span className='username'>Super Admin</span>
                </span>
              </div>
            </div>
          </div>

          {selectedSection == 'section1' ? (
            <>
              <section id='analyticsSection'>
                <div className='counter-item-wrapper'>
                  <div className='counter-tems'>
                    <Counter
                      backgroundColor={colorTheme.primaryGreen}
                      title={'Upcoming Events'}
                      count={upcomingEventsCount}
                      Icon={<AiOutlineRise style={{ color: 'white' }} />}
                    />
                  </div>
                  <div className='counter-tems'>
                    <Counter
                      backgroundColor={'#3498db'}
                      title={'Past Events'}
                      count={pastEventsCount}
                      Icon={<AiOutlineCalendar style={{ color: 'white' }} />}
                    />
                  </div>
                  {/* <div className='counter-tems'>
                    <Counter
                      backgroundColor={colorTheme.primaryGreen}
                      title={'Announc Count'}
                      ContactCount={data?.ContactCount ? data?.ContactCount : 0}
                      Icon={<MdContactPhone style={{ color: 'white' }} />}
                    />
                  </div> */}
                  {/* <div className='counter-tems'>
                    <Counter
                      backgroundColor={colorTheme.primaryOrange}
                      title={'Today appointments Count'}
                      ContactCount={
                        data?.AppointmentsCount ? data?.AppointmentsCount : 0
                      }
                      Icon={<AiFillSchedule style={{ color: 'white' }} />}
                    />
                  </div> */}
                </div>
              </section>

              <div className='row'>
                <div className='col-md-6 mb-4'>
                  <div className='chartSection'>
                    <h3 className='mb-4'>Upcoming Events Data</h3>
                    <ChartsMain
                      upcomingEventsChartData={upcomingEventsChartData}
                    />
                  </div>
                </div>
                <div className='col-md-6 mb-4'>
                  <div className='chartSection'>
                    <h3 className='mb-4'>Past Events Data</h3>
                    <PieChart pastEventsChartData={pastEventsChartData} />
                  </div>
                </div>
              </div>
            </>
          ) : selectedSection == 'section3' ? (
            <>
              <div
                id='notificationlist'
                className='chartSection mb-4 position-relative'
              >
                <h5 className='mb-3'>Upcoming Events List</h5>
                <div
                  style={{
                    alignSelf: 'flex-end',
                    justifyContent: 'flex-end',
                    alignItems: 'flex-end',
                    display: 'flex',
                    marginTop: -40,
                    marginBottom: 15,
                  }}
                >
                  <button
                    className='reidPrimaryBtn btn w-auto'
                    onClick={() => {
                      setShowComingEventModal(true);
                    }}
                  >
                    <FaPlus
                      style={{
                        height: '13px',
                        width: '13px',
                        marginRight: '4px',
                      }}
                    />
                    Event
                  </button>
                </div>
                <div className='table-responsive'>
                  <UpcomingEventList
                    updateNotificationsList={updateNotificationsList}
                    setUpdateNotificationsList={setUpdateNotificationsList}
                    isAnnoucementReload={isAnnoucementReload}
                    setIsAnnoucementReload={setIsAnnoucementReload}
                    setAnnouncementModal={setShowComingEventModal}
                    showComingEventModal={showComingEventModal}
                  />
                </div>
              </div>
            </>
          ) : selectedSection == 'section2' ? (
            <>
              <div
                id='notificationlist'
                className='chartSection mb-4 position-relative'
              >
                <div
                  style={{
                    alignSelf: 'flex-end',
                    justifyContent: 'flex-end',
                    alignItems: 'flex-end',
                    display: 'flex',

                    marginBottom: 15,
                    position: 'absolute',
                    right: '2.5%',
                  }}
                >
                  <button
                    className='reidPrimaryBtn btn w-auto'
                    onClick={() => {
                      setShowPastEventModal(true);
                    }}
                  >
                    <FaPlus
                      style={{
                        height: '13px',
                        width: '13px',
                        marginRight: '4px',
                      }}
                    />
                    Event
                  </button>
                </div>
                <h5 className='mb-3'>Past Events List</h5>
                <div
                  style={{
                    alignSelf: 'flex-end',
                    justifyContent: 'flex-end',
                    alignItems: 'flex-end',
                    display: 'flex',
                    marginTop: -10,
                    marginBottom: 15,
                  }}
                ></div>
                <div className='table-responsive'>
                  <PastEventList
                    updateNotificationsList={updateNotificationsList}
                    setUpdateNotificationsList={setUpdateNotificationsList}
                    isAnnoucementReload={isAnnoucementReload}
                    setIsAnnoucementReload={setIsAnnoucementReload}
                    setAnnouncementModal={setShowEventRecordingModal}
                    showEventRecordingModal={showEventRecordingModal}
                    setShowPastEventModal={setShowPastEventModal}
                    isPastEvent={true}
                    showPastEventModal={showPastEventModal}
                  />
                </div>
              </div>
            </>
          ) : null}

          <div className='footer-container d-block d-md-flex'>
            <div className='footer-left d-none d-md-block'>
              <span className='copyright'>
                Copyright 2024 © <span>MyReid</span> - All rights reserved.
              </span>
            </div>
            <div className='footer-right text-center text-md-end'>
              <img
                className='footer-image'
                width={150}
                src={footerLogo}
                alt='footer-image'
              ></img>
            </div>
          </div>
        </div>
      </div>
      {showComingEventModal && (
        <AddUpcomingEventModal
          handleClose={() => setShowComingEventModal(false)}
          show={showComingEventModal}
          updateNotificationsList={updateNotificationsList}
          setUpdateNotificationsList={setUpdateNotificationsList}
          setIsAnnoucementReload={setIsAnnoucementReload}
        />
      )}
      {showPastEventModal && (
        <AddPastEventModal
          handleClose={() => setShowPastEventModal(false)}
          show={showPastEventModal}
          updateNotificationsList={updateNotificationsList}
          setUpdateNotificationsList={setUpdateNotificationsList}
          setIsAnnoucementReload={setIsAnnoucementReload}
        />
      )}
      {showEventRecordingModal && (
        <AddEventRecordingModal
          handleClose={() => setShowEventRecordingModal(false)}
          show={showEventRecordingModal}
          updateNotificationsList={updateNotificationsList}
          setUpdateNotificationsList={setUpdateNotificationsList}
          setIsAnnoucementReload={setIsAnnoucementReload}
        />
      )}

      {logoutAlert && (
        <WarningAlert
          message={'Do you want to Logout?'}
          onCancel={() => setLogoutAlert(false)}
          ondelete={userLogout}
        />
      )}

      {showWarning && (
        <ErrorAlert
          message={message}
          onClose={() => {
            setShowWarning(false);
          }}
        />
      )}
    </>
  );
};
